import {Container} from "react-bootstrap";

function Privacy(props) {
  return (
    <Container>
      [Privacy Policy]
    </Container>
  );
}

export default Privacy;